import React from 'react';
import { Link } from 'react-router-dom';
import { asset } from '../data/redesignAssets';
import { DEMO_URL, SIGN_IN_URL } from '../data/links';
export function Footer() {
  return <footer className="foot bleed" data-id="element-56" data-mp="32o4bucrusc7l">
      <div className="foot-g" data-id="element-57" data-mp="32ovz90bar3ms">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-58" data-mp="32lrkj907gphv">
          <img src={asset('meetsynthia-logo-lockup.svg')} alt="meetsynthia" style={{
          height: 26,
          width: 'auto',
          display: 'block',
          alignSelf: 'flex-start'
        }} data-id="element-59" data-mp="36q90ex3g2ind" />
          <div style={{
          maxWidth: 320,
          fontSize: 14,
          lineHeight: 1.55,
          color: 'var(--mut)'
        }} data-id="element-60" data-mp="38h81hlebwon">
            Instruction governance for enterprise AI.
          </div>
        </div>
        <div className="fc" data-id="element-61" data-mp="3lgosmvua2qv1">
          <div className="fh" data-id="element-62" data-mp="3qcx86ace0m2q">PRODUCT</div>
          <Link to="/how" data-id="element-63" data-mp="3qblwzpgm4c1l">How it works</Link>
          <Link to="/#atomizer" data-id="element-64" data-mp="29zgnu9fpz8qc">Try the Atomizer</Link>
          <a href={DEMO_URL} target="_blank" rel="noopener" data-id="element-65" data-mp="29xvrce9uhfpu">
            Book a demo
          </a>
          <a href={SIGN_IN_URL} target="_top" rel="noopener" data-id="element-66" data-mp="2ezl5i2sd69i5">
            Sign in
          </a>
        </div>
        <div className="fc" data-id="element-67" data-mp="3lbmu7sfd78fw">
          <div className="fh" data-id="element-68" data-mp="3gapd7j63ckfz">COMPANY</div>
          <Link to="/about" data-id="element-69" data-mp="3gc0ftfnsvm5i">About</Link>
          <Link to="/blog" data-id="element-70" data-mp="3v7q5pow3wjfi">Blog</Link>
          <Link to="/contact" data-id="element-71" data-mp="3v8rhxwouzbyt">Contact</Link>
        </div>
        <div className="fc" data-id="element-72" data-mp="3v5dhitzr9cu0">
          <div className="fh" data-id="element-73" data-mp="3q83q58st2r3j">GET IN TOUCH</div>
          <a href="mailto:hello@meetsynthia.ai" data-id="element-74" data-mp="3q7bz8ba5lhjl">hello@meetsynthia.ai</a>
          <a href="mailto:sales@meetsynthia.ai" data-id="element-75" data-mp="81pgvn5hf5bh">sales@meetsynthia.ai</a>
          <div style={{
          color: 'var(--mut)',
          fontWeight: 400
        }} data-id="element-76" data-mp="34gxxkciex96">New York, NY</div>
        </div>
      </div>
      <div className="foot-b" data-id="element-77" data-mp="ht3ajear5awp">
        <span data-id="element-78" data-mp="hsadj51lhzrr">© 2026 Synthia, Inc. All rights reserved. · patents pending</span>
        <div style={{
        display: 'flex',
        gap: 20
      }} data-id="element-79" data-mp="cus29803v8gl">
          <Link to="/privacy" className="foot-lk" data-id="element-80" data-mp="cw36ta1dkk8r">
            Privacy
          </Link>
          <Link to="/terms" className="foot-lk" data-id="element-81" data-mp="qrfboa98vr3e">
            Terms of service
          </Link>
        </div>
      </div>
    </footer>;
}